import React from 'react'

import UserIcon from "../../../../core/gd-ui/icon/user/user"
import Pin from "../../../../core/gd-components/pin/v2/pin"
import {toggleClass} from "../../../../core/gd/utils/dom-and-react/react-utils"
import {findDOMNode} from "react-dom"
import {BUS_APP_LAUNCH} from "../../../../core/gd/app-manager/@event"

// @ts-ignore
// import NavigationMenuItemUserMore from "./user-more-menu"

// const debug = "NavigationMenuItemUser"
const debug = false

export default class NavigationMenuItemUser extends React.Component<any, any> {

    private node: any

    constructor(props:any) {
        super(props);

        const fragment = gd.router.history.fragment || ''
        const isSelected = _.startsWith(fragment, 'u/') && fragment.includes(this.props.companyUser.id)

        debug && console.log(debug, "constructor", _.startsWith(fragment, 'u/'), fragment.includes(this.props.companyUser.id), this.props.companyUser.id, fragment)

        this.state = {
            selected: isSelected,
            showPopover: false
        }
    }

    componentDidMount() {
        this.node = findDOMNode(this)
        gd.bus.subscribe(BUS_APP_LAUNCH, this, this.onLaunchApp)
    }

    componentWillUnmount = () => {
        gd.bus.unsubscribe(this)
    }

    onLaunchApp = (data:any) => {
        debug && console.log(debug, "onLaunchApp", this.props.companyUser.id, data)
        // const companyUser = gd.session.companyUsers.get(this.props.companyUser.id);
        // if (!companyUser) return //companyUser may be removed

        if (this.state.selected) {
            if (data.params.id !== this.props.companyUser.id) {
                this.setState({selected: false});
            }
        } else {
            if (data.params.id === this.props.companyUser.id) {
                this.setState({selected: true});
            }
        }
    }

    onClick = () => {
        gd.goTo('u/'+this.props.companyUser.id)
    }

    onTogglePopover = (showPopover: boolean) => {
        toggleClass(this.node, 'show-popover', showPopover)
    }

    render() {
        const classes = Classes('item user', 'userId-'+this.props.companyUser.id /*required for scroll to node*/, {
            'selected'      : this.state.selected,
            'dnd-preview'   : this.props.dndPreview,
            'dnd-is-dragged': this.props.dndIsDragged,
        });

        // style is required for ReorderList (pointer-events: none)
        return (
            <div className={classes} style={this.props.style} onClick={this.onClick}>
                <div className="row">
                    <UserIcon userId={this.props.companyUser.user.id} size="22" className="avatar-22"/>
                    <div className="name">{this.props.companyUser.user.name}</div>
                    {/*<NavigationMenuItemUserMore companyUser = {this.props.companyUser} />*/}

                    <Pin className          = "more"
                         data               = {{
                             userId          : this.props.companyUser.user.id,
                             organizationId  : gd.companyId
                         }}
                         onTogglePopover    = {this.onTogglePopover}/>
                </div>
            </div>
        )
    }
}
